import { CustomComponentProps } from "utils/types/generalTypes";
// import SVG from "../core/SVG";

import userPlaceHolder from "assets/img/user_icon.png";
import { ChatMsgObj } from "assets/data/chatData";
import { useLongPress } from "use-long-press";
import { useRef, useState } from "react";
import { useOnClickOutside } from "usehooks-ts";

export type SendedMsgProps = CustomComponentProps & {
    msg: ChatMsgObj;
    setPreviewImg: React.Dispatch<React.SetStateAction<string | undefined>>;
};

const RecievedMsg = ({
    msg,
    setPreviewImg,
    className,
    style
}: SendedMsgProps) => {
    const [showDropdown, setShowDropDown] = useState(false);
    const dropdownRef = useRef(null);
    useOnClickOutside(dropdownRef, () => setShowDropDown(false));

    const bind = useLongPress(() => {
        setShowDropDown(true);
    });
    return (
        <div
            className={`recieved-msg chat-msg d-flex flex-row flex-j-start flex-a-end gap-5 ${className}`}
            style={style}
        >
            <div className="msg-pic-col d-flex flex-col gap-5 flex-j-end flex-a-center">
                <img
                    src={msg.user.url || userPlaceHolder}
                    alt={msg.user.name}
                />
            </div>
            <div className="d-flex flex-col flex-j-end flex-a-start gap-5 w-full p-relative">
                {msg.msg ? (
                    <div className="chat-msg-div" {...bind()}>
                        {msg.msg}
                    </div>
                ) : (
                    <img
                        src={msg.img}
                        alt="img"
                        className="chat-msg-img cursor-pointer"
                        {...bind()}
                        onClick={() => setPreviewImg(msg.img)}
                    />
                )}
                <div className="time">{msg.time}</div>
                <div
                    className={`${!showDropdown && "is-hidden"}  my-dropdown right box-shadow cursor-default `}
                    ref={dropdownRef}
                >
                    <div className="drop-item cursor-pointer">
                        Delete Message
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecievedMsg;
